export type PanelOrientations = { width: boolean; height: boolean }

export const getMapPanForSizeChange = ({
  width,
  oldWidth,
  height,
  oldHeight,
  isLandscape,
  orientationAtLastChange,
}: {
  width: number
  oldWidth: number | undefined
  height: number
  oldHeight: number | undefined
  isLandscape: boolean
  orientationAtLastChange: PanelOrientations
}) => {
  // Width and height are debounced separately, so after a turn they can land in separate renders.
  // Each is compared with the orientation it was last measured in, so the first to land cannot hide the second.
  const widthTurned = orientationAtLastChange.width !== isLandscape
  const heightTurned = orientationAtLastChange.height !== isLandscape

  const nextOrientationAtLastChange = {
    width: width === oldWidth ? orientationAtLastChange.width : isLandscape,
    height: height === oldHeight ? orientationAtLastChange.height : isLandscape,
  }

  if (oldWidth === undefined || oldHeight === undefined) {
    return { pan: null, orientationAtLastChange: nextOrientationAtLastChange }
  }

  const x = widthTurned ? 0 : (width - oldWidth) / 2
  const y = heightTurned ? 0 : (height - oldHeight) / 2

  return { pan: x === 0 && y === 0 ? null : { x, y }, orientationAtLastChange: nextOrientationAtLastChange }
}
